module.exports = __webpack_public_path__ + "img/Ying'n_flow_white.02426eaa.png";